import React, { useCallback } from "react"

export const openNavigationEvent = new Event("neo__open_navigation")

const ClientBurgerButton = () => {
  const openSideNavigation = useCallback(() => {
    document.dispatchEvent(openNavigationEvent)
  }, [])

  return (
    <div className="neo__clientHeader__burgerButton" onClick={openSideNavigation}>
      <span className="neo__clientHeader__burgerIcon" />
    </div>
)
}

export default ClientBurgerButton